import { BodyFieldsPropperties } from "../constants"
import { TgMailing } from "../interfaces"

export function useMailingFieldsParameters(method: TgMailing.AvailableMethods) {
  return BodyFieldsPropperties[method]
}
